/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a target date and time to start the countdown.`)
};

const es_cd_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una fecha y hora objetivo para iniciar la cuenta atrás.`)
};

const de_cd_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle ein Zieldatum und eine Uhrzeit, um den Countdown zu starten.`)
};

const nl_cd_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een doeldatum en -tijd om de aftelling te starten.`)
};

const fr_cd_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez une date et une heure cible pour démarrer le compte à rebours.`)
};

const it_cd_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli una data e un'ora obiettivo per avviare il conto alla rovescia.`)
};

const pt_br2_cd_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma data e hora alvo para iniciar a contagem regressiva.`)
};

const pt_cd_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma data e hora alvo para iniciar a contagem decrescente.`)
};

const ja_cd_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カウントダウンを開始するには目標日時を選んでください。`)
};

const zh_cd_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择目标日期和时间以开始倒计时。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_hint", locale)
	if (locale === "en") return en_cd_hint(inputs)
	if (locale === "es") return es_cd_hint(inputs)
	if (locale === "de") return de_cd_hint(inputs)
	if (locale === "nl") return nl_cd_hint(inputs)
	if (locale === "fr") return fr_cd_hint(inputs)
	if (locale === "it") return it_cd_hint(inputs)
	if (locale === "pt-BR") return pt_br2_cd_hint(inputs)
	if (locale === "pt") return pt_cd_hint(inputs)
	if (locale === "ja") return ja_cd_hint(inputs)
	return zh_cd_hint(inputs)
};